export default __webpack_public_path__ + "static/media/Websitelogo.66ae6d72.svg";